import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';

import { CommonService } from "../../../_common/_service/user.service";
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BeforePaymentConfirmDialogComponent } from '../../popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';

import { ConfirmbanktransferDialogComponent } from '../../popup/confirm-banktransfer-dialog/confirm-banktransfer-dialog.component';
import { ConfirmDialogComponent } from '../../popup/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-banktransfer',
  templateUrl: './banktransfer.component.html',
  styleUrls: ['./banktransfer.component.scss']
})
export class BanktransferComponent implements OnInit {
  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;
  recentReceiver: any;
  //show = 2;
  banktransferForm: FormGroup;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  //countryIsdcode: any;
  OperatorName: any;

  BeneficiaryInfoList: any;
  FullBeneficiaryInfo: any;
  AccountCode: any;
  payoutCurrency: any;

  public BeneficiaryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();

  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy1 = new Subject<void>();
  beneficiary_country: any;
  beneficiary_phone: any;
  ActualAmount: any;
  editId: any;
  loadingspinner: boolean = false;
    beneficiary_account_no: any;


  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService,
    private _service: CommonService) {

    //this.countryIsdcode = localStorage.getItem('countryIsdcode');
    //AccountCode == channel selected code
    //channel == channel selected name
    this.banktransferForm = this.fb.group({
      AccountCode: [null, [Validators.required]],
      PaymentModeCode: ["RRP"],
      Amount: [null, [Validators.required]],
      Id: [null, [Validators.required]],
      Comment: [null],
      DeviceType: "web",

    })

  }


  ngOnInit(): void {
    this.token = this.tokenStorageService.getToken();
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();
      this.getcountryList();
      //this.getBeneficiaryInfo();
      // listen for search field value changes
      this.BeneficiaryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBeneficiary();
        });

      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy1))
        .subscribe(() => {
          this.filterCountry();
        });
    }
    else {
      this._service.callMethodOfSecondComponent();
    }

    this.f.Amount.valueChanges.subscribe(val => {
      if (val == "") {
        this.commissionFee = 0;
        this.commissionTotal = 0;
      }

      if (val && val.length > 0) {
        if (this.f.PaymentModeCode.value && this.AccountCode) {
          debugger
          this.getServiceCommissionList(this.f.Amount.value, this.f.PaymentModeCode.value, this.AccountCode);
        }
        else {
          this.toastr.error("Selected Proper Option", 'Error');
        }
      }
    });
  }


  Back() {
    this.router.navigate(['/Go-on']);
  }

  get f() { return this.banktransferForm.controls; }

  //GetCurrentchannelVal(code: any, name: any) {

  //  this.f.Comment.setValue(null);
  //  //this.f.MobileMoneySource.setValue(null);
  //  this.f.Amount.setValue(null);
  //  // this.f.BeneficiaryName.setValue(null);
  //  this.commissionFee = 0;
  //  this.commissionTotal = 0;
  //  this.OperatorName = name;
  //  this.submitted = false;

  //  this.authService.getchannelList(code, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
  //    ;
  //    if (response.apiStatus == true) {
  //      ;
  //      this.channelList = response.apiData;

  //    }
  //    else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
  //      this.toastr.warning(response.apiMessage, 'Warning');
  //      this._service.callMethodOfSecondComponent();
  //    }
  //    else {
  //      this.toastr.error(response.apiMessage, 'Error');
  //    }

  //  }, (err: any) => {
  //    if (err.error instanceof Error) {
  //      this.toastr.error(err.error, 'Error');
  //    } else {

  //      this.toastr.error(err.error, 'Error');
  //    }
  //  }
  //  );


  //  this.viewTransactions(code);
  //}


  openAddBeneficiaryDetails() {
    this.router.navigate(['/Banktransferbeneficiary'], { queryParams: { serviceCode: this.serviceCode }, skipLocationChange: true });
  }

  //openPasswordDialog(post: any) {
  //  
  //  this.submitted = true;
  //  if (this.banktransferNigeriaForm.valid) {
  //    const dialogRef = this.dialog.open(ConfirmPasswordDialogComponent, {
  //      width: '450px',
  //      data: null
  //    });

  //    dialogRef.afterClosed().subscribe(result => {
  //      if (result !== undefined && result !== null && result) {
  //        post.Password = result;
  //        this.payMobMon(post);
  //      }
  //    });

  //  }
  //}
  string1: any;
  paymobileMoneyForm(post: any) {
    //
    this.submitted = true;
    if (this.banktransferForm.valid) {
      this.loadingspinner = true;
      var PayServicsReq = null;
      var AddServicsReq = null;

      //pop up 
      AddServicsReq = {
        Amount: parseFloat(post.Amount), AccountCode: post.PaymentModeCode
      }
      //form 
      PayServicsReq = {
        Amount: parseFloat(post.Amount), MobileMoneySource: this.AccountCode,
        BeneficiaryName: null, Comment: post.Comment, AccountCode: post.AccountCode

      }

      //
      var post1 = {
        //form
        PayServicsReq: JSON.stringify(PayServicsReq),
        //popup
        AddServicsReq: JSON.stringify(AddServicsReq),
        ServiceCode: this.serviceCode,
        PaymentModeCode: post.PaymentModeCode,
        DeviceType: "web"

      }

      // Convert String obect to JSON
      this.stringJson = JSON.stringify(post1);
      ////////console.log("String json object :", this.stringJson);

      //  // ConvertjSON to an object
      //  this.stringObject = JSON.parse(this.stringJson);
      //  ////////console.log("JSON object -", this.stringObject);
      debugger;
      this.authService.paytransfertoBank(this.stringJson, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
        debugger;
        this.loadingspinner = false;
        debugger;
       
        const filterValueStr = response.apiData.eziPayReferenceId;
       

        
        if (response.apiStatus == true && response.apiData.transactionStatus == 2) {
          this.data = response.apiData;
          ////////console.log("data succ response -", this.data);
          
          
          if (response.apiMessage == "SUCCESSFUL") {
            this.banktransferForm.reset();
            this.submitted = false;
            this.commissionFee = 0;
            this.commissionTotal = 0;
            this.ActualAmount = 0;
            this.openPaymentConfirmDialog(this.data);
          }
         
          else {
            this.toastr.error(response.apiMessage, 'Transaction Status');
          }

          this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal          
        }

        else if (response.apiMessage == "PENDING" && response.apiData.transactionStatus == 4 && filterValueStr.includes('SAU02')) {
          
          this.banktransferForm.reset();
          this.submitted = false;
          this.commissionFee = 0;
          this.commissionTotal = 0;
          this.ActualAmount = 0;
          this.msgDialog();
        }
        else if (response.apiStatus == true) {
          this.submitted = false;
          this.toastr.success(response.apiMessage, 'Success');
          this.commissionFee = 0;
          this.commissionTotal = 0;
          this.ActualAmount = 0;
          this.banktransferForm.reset();
        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }

  msgDialog() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      width: '550px',
      data: {
        title: 'The beneficiary will receive an SMS prompting him/her to follow a link to onboard and be able to receive the payment. The transaction will be held on pending status till the process is complete. Funds will be pushed to the beneficiary account once the process is complete. Cancellation time for cases where the onboarding cannot be done Transactions are canceled after 6 days of not successfully receiving details'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {


      }
    });
  }

  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {
    ;
    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;
        this.ActualAmount = this.commissionList.actualAmount;
        this.payoutCurrency = response.apiData.payoutCurrency;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  getcountryList() {
    this.submitted = false;

    this.authService.getchannelList(this.serviceCode, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      ;
      if (response.apiStatus == true) {
        this.OptionList = response.apiData;

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }




  openPaymentConfirmDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });

  }


  viewTransactions(val: any) {

    this.authService.getUserOrdersdetails1(val, this.currentUser.serviceid).subscribe(response => {
      ;
      if (response.apiStatus == true) {
        this.userorderdetailList = response.apiData;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }


  openDialog(post: any) {
    debugger;
    this.submitted = true;
    if (this.banktransferForm.valid) {
      post.serviceName = 'Transfer To Bank';
      post.commissionFee = this.commissionFee;
      post.OperatorName = this.OperatorName;
      post.beneficiary_country = this.beneficiary_country;
      post.beneficiary_phone = this.beneficiary_phone;
      post.beneficiary_account_no = this.beneficiary_account_no;
      const dialogRef = this.dialog.open(BeforePaymentConfirmDialogComponent, {
        width: '450px',
        disableClose: true,
        hasBackdrop: true, // or false, depending on what you want
        autoFocus: false,
        maxHeight: '90vh', //you can adjust the value as per your view
        data: post
      });

      dialogRef.afterClosed().subscribe(result => {
        ;
        if (result !== undefined && result !== null && result) {

          this.paymobileMoneyForm(post);
        }
      });

    }
  }


  getBeneficiaryInfo(codeval: any) {
    debugger;
    this.f.Id.setValue(null);
    this.f.Amount.setValue(null);
    this.f.Comment.setValue(null);
    this.commissionFee = 0;
    this.commissionTotal = 0;
    this.ActualAmount = 0;
    this.amt = 0;

    this.authService.GetbanktransferBeneficiaryDetails(codeval).subscribe(response => {
      debugger
      this.BeneficiaryInfoList = response;
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );
    //this.viewTransactions(codeval);
  }

  GetBeneficiaryInfobyId(Id: any, value: any, channel: any, beneficiary_country: any, beneficiary_phone: any, beneficiary_account_no: any) {
    debugger;
    this.AccountCode = value;
    this.OperatorName = channel;
    this.beneficiary_country = beneficiary_country;
    this.beneficiary_phone = beneficiary_phone;
    this.beneficiary_account_no = beneficiary_account_no;
    this.editId = Id; //for edit
    this.authService.GetbanktransferBeneficiaryDetailsbyId(Id).subscribe(response => {
      ;
      ////////console.log(response[0]);
      this.openBeneficiaryDialog(response[0]);

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }


  openBeneficiaryDialog(post: any) {
    post.editId = this.editId; //for edit
    this.submitted = true;
    const dialogRef = this.dialog.open(ConfirmbanktransferDialogComponent, {
      width: '550px',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      autoFocus: false,
      maxHeight: '90vh', //you can adjust the value as per your view
      data: post
    });

    dialogRef.afterClosed().subscribe(result => {

    });


  }

  filterBeneficiary() {

    if (this.BeneficiaryFilterCtrl.value) {

      return this.BeneficiaryInfoList.filter((x: { text: string; }) => x.text.toLowerCase().indexOf(this.BeneficiaryFilterCtrl.value.toLowerCase()) > -1);
    } else {
      return this.BeneficiaryInfoList;
    }
  }

  filterCountry() {

    if (this.CountryFilterCtrl.value) {

      return this.OptionList.payservices.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.OptionList?.payservices;
    }
  }
}
